import type { Screen } from "../screens/Screen";
import type { RenderHost } from "./RenderHost";

export class RenderEngine implements RenderHost {

    constructor(
        private readonly root: HTMLElement
    ) {}

    // =========================
    // SCREEN HOST
    // =========================

    public showScreen(
        screen: Screen
    ): void {

        this.root.innerHTML = "";

        this.root.appendChild(
            screen.getRoot()
        );

    }

}